export const BASE_URL = 'https://api.thejacksonsplace.com';
//export const BASE_URL = 'http://192.168.1.234:1339';
export const STRIPE_SECRET_KEY="sk_test_xxx"
export const STRIPE_WEBHOOK_SECRET="whsec_xxx"
export const STRIPE_PRICE_STARTER="price_xxx"
export const STRIPE_PRICE_GROWTH="price_xxx"
